<template>
  <section class="aso-identidade-step">
    <!-- Fluxo trabalhador novo: apenas input CPF -->
    <template v-if="!cadastroExistente">
      <h2 class="aso-identidade-step__title">Valide sua identidade.</h2>
      <p class="aso-identidade-step__text">Informe o CPF para confirmar seus dados na consulta.</p>

      <input
        class="aso-identidade-step__input"
        type="text"
        inputmode="numeric"
        maxlength="14"
        :value="cpf"
        placeholder="000.000.000-00"
        :disabled="busy"
        @input="$emit('update:cpf', $event.target.value)"
      >

      <button
        type="button"
        class="aso-identidade-step__button aso-flow-button aso-flow-button--loud aso-flow-button--full"
        :disabled="busy"
        @click="$emit('validate')"
      >
        {{ busy ? 'Validando...' : 'Continuar' }}
      </button>
    </template>

    <!-- Fluxo trabalhador existente: inputs com dados mascarados + switch edição -->
    <template v-else>
      <h2 class="aso-identidade-step__title">Bem vindo de volta!</h2>
      <p class="aso-identidade-step__text">Confira seus dados cadastrados. Caso necessário, habilite a edição para atualizá-los.</p>

      <div class="aso-identidade-step__toggle-row">
        <label class="aso-identidade-step__switch-label">
          <span class="aso-identidade-step__switch-text">Deseja editar suas informações? <strong>{{ editavel ? 'Sim' : 'Não' }}</strong></span>
          <span
            class="aso-identidade-step__switch"
            :class="{ 'aso-identidade-step__switch--on': editavel }"
            role="switch"
            :aria-checked="String(editavel)"
            tabindex="0"
            @click="!busy && $emit('toggle-edit', !editavel)"
            @keydown.enter.prevent="!busy && $emit('toggle-edit', !editavel)"
            @keydown.space.prevent="!busy && $emit('toggle-edit', !editavel)"
          >
            <span class="aso-identidade-step__switch-thumb"></span>
          </span>
        </label>
      </div>

      <div v-if="editavel" class="aso-identidade-step__warning-card">
        <div class="aso-identidade-step__warning-header">
          <svg class="aso-identidade-step__warning-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L1 21h22L12 2z" fill="#ffc107" stroke="#e6ac00" stroke-width="1"/>
            <text x="12" y="18" text-anchor="middle" font-size="14" font-weight="bold" fill="#5a4000">!</text>
          </svg>
          <p class="aso-identidade-step__warning-text">Para atualizar o cadastro, todos os campos precisam ser editados:</p>
        </div>
        <ul class="aso-identidade-step__warning-list">
          <li>Nome</li>
          <li>CPF</li>
          <li>Sexo</li>
          <li>Data de Nascimento</li>
        </ul>
      </div>

      <div class="aso-identidade-step__field">
        <label class="aso-identidade-step__field-label">Nome completo</label>
        <input
          class="aso-identidade-step__input"
          type="text"
          :value="editavel ? nome : maskedNome"
          :disabled="!editavel || busy"
          placeholder="Nome completo"
          @input="$emit('update:nome', $event.target.value)"
        >
      </div>

      <div class="aso-identidade-step__field">
        <label class="aso-identidade-step__field-label">CPF</label>
        <input
          class="aso-identidade-step__input"
          type="text"
          inputmode="numeric"
          maxlength="14"
          :value="editavel ? cpf : maskedCpf"
          :disabled="!editavel || busy"
          placeholder="000.000.000-00"
          @input="$emit('update:cpf', $event.target.value)"
        >
      </div>

      <div class="aso-identidade-step__field">
        <label class="aso-identidade-step__field-label">Sexo</label>
        <select
          class="aso-identidade-step__input"
          :value="sexo"
          :disabled="!editavel || busy"
          @change="$emit('update:sexo', $event.target.value)"
        >
          <option value="">Selecione</option>
          <option value="M">Masculino</option>
          <option value="F">Feminino</option>
        </select>
      </div>

      <div class="aso-identidade-step__field">
        <label class="aso-identidade-step__field-label">Data de nascimento</label>
        <input
          class="aso-identidade-step__input"
          type="date"
          :value="dataNascimento"
          :disabled="!editavel || busy"
          @input="$emit('update:dataNascimento', $event.target.value)"
        >
      </div>

      <button
        type="button"
        class="aso-identidade-step__button aso-flow-button aso-flow-button--loud aso-flow-button--full"
        :disabled="busy"
        @click="$emit('validate')"
      >
        {{ busy ? 'Salvando...' : (editavel ? 'Salvar e continuar' : 'Continuar') }}
      </button>
    </template>
  </section>
</template>

<script>
export default {
  name: 'AsoValidarIdentidadeStep',
  props: {
    cpf: {
      type: String,
      default: '',
    },
    busy: {
      type: Boolean,
      default: false,
    },
    cadastroExistente: {
      type: Boolean,
      default: false,
    },
    editavel: {
      type: Boolean,
      default: false,
    },
    nome: {
      type: String,
      default: '',
    },
    maskedNome: {
      type: String,
      default: '',
    },
    maskedCpf: {
      type: String,
      default: '',
    },
    sexo: {
      type: String,
      default: '',
    },
    dataNascimento: {
      type: String,
      default: '',
    },
  },
}
</script>



// WEBPACK FOOTER //
// AsoValidarIdentidadeStep.vue?9139e104